export function isClient() {
  return !isServer()
}

export function isServer() {
  // @ts-ignore
  return typeof window === 'undefined'
}
